__turbopack_context__.v({
  "graph": "OrganizationSparkline-module-scss-module__4XN01q__graph",
  "graphWrapper": "OrganizationSparkline-module-scss-module__4XN01q__graphWrapper",
  "navButton": "OrganizationSparkline-module-scss-module__4XN01q__navButton",
  "swipeHint": "OrganizationSparkline-module-scss-module__4XN01q__swipeHint",
  "yearNavigation": "OrganizationSparkline-module-scss-module__4XN01q__yearNavigation",
});
